
/* injects from baggage-loader */

'use strict';

import AdminController from './admin.controller';
import AdminTemplate from './admin.html';

export default class AdminComponent {
		constructor() {
				this.templateUrl = AdminTemplate;
				this.controller = AdminController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/admin.component.js